import { FILTER_OPERATOR_ENUMS, FILTER_RULE_ENUMS } from '@constants';
import { generateShortId } from '@utils';
import { ENTITIES_PERMISIONS_NAMES } from 'components/common/PermissionsGate/constants';
import { pick } from 'lodash-es';

export const handlePermissionsData = (data) => {
  if (!data) {
    return [];
  }

  return data?.map((item) => ({
    id: item?.id || generateShortId(),
    role: item.role || '-',
    permission: ENTITIES_PERMISIONS_NAMES[item?.permission] || '-',
  }));
};

export const getAsyncExportPayload = (payload = {}) => {
  const fields = pick(payload, 'role');

  const _getValue = ({ field }) => {
    return payload[field];
  };
  const _getType = () => {
    return FILTER_RULE_ENUMS.ComparableRuleType;
  };

  const value = [
    ...Object.keys(fields).map((field) => ({
      field,
      operator: FILTER_OPERATOR_ENUMS['='],
      type: _getType(),
      value: _getValue({ field }),
    })),
  ];

  if (value.length) {
    return {
      type: FILTER_RULE_ENUMS.AndRuleType,
      field: null,
      operator: null,
      value,
    };
  }

  return {
    type: FILTER_RULE_ENUMS.EmptyRuleType,
  };
};
